module.exports = __webpack_public_path__ + "assets/01.a19c7f35.pdf";